import React from 'react'
import { useTranslate } from './TranslationText'
import FilterButton from './FilterButton';
import NetaqInput from './NetaqInput';
import NewActionButton from './ActionButtons/NewActionButton';

export default function SearchBox({
    value,
    onChange,
    onKeyDown,
    isForm = false,
    onSubmit = () => { },
    onClick = () => { },
    onFilterClick = () => { },
    isWithSubmitBTN = false,
    onSubmitBtnFunction = () => { },
    optionsList = [],
    onOptionSelect = () => { },
    resultCount = 0,
    placeholder = '',
    showMoreFilter = false,
    isStudBookPage = false,
    isPadding=false,
    isFullWidth = false,
}) {

    const { translate } = useTranslate();
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const defaultPlaceHolder = !!placeholder ? placeholder : translate('web.search', 'search');
    const formMainClass = `${isFullWidth ? showMoreFilter ? `col-md-7 col-sm-12 col-12 ${isPadding? "":"px-0" } ` : `col-md-12 col-sm-12 col-12 ${isPadding? "":"px-0" }` : 'col-md-4 col-sm-4 col-12'}  ms-auto  mb-form-group position-relative`;
    if (isForm) {
        return (
            <>
                <form className="row mx-0  rtl   justify-content-center" onSubmit={onSubmit}>
                    <div className={formMainClass}>
                        <div className="input-group">
                            <NetaqInput
                                name='searchbox'
                                type='text'
                                value={value}
                                onChange={onChange}
                                placeholder={defaultPlaceHolder}
                            />
                            <div onClick={onClick} className="btn btn-danger input-group-append d-flex  align-items-center justify-content-center" style={{ cursor: 'pointer', zIndex: 2000 }}>
                                <i className=" fa fa-search" ></i>
                            </div>
                        </div>
                    </div>
                    {showMoreFilter && (
                        <div className='col-md-5 col-sm-12 col-12   pe-0  ps-md-2 ps-0  mb-main' >
                            <NewActionButton
                                onClick={onFilterClick}
                                text={<>
                                    {translate('web.filter', 'filter')}
                                </>}
                            />
                        </div>
                    )}

                </form>
            </>
        )
    }
    else {
        return (
            <div className="row rtl  ">
                <div className={formMainClass}>
                    <div className="input-group">
                        <input className="form-control border-end-0 border rounded" type="text" id="example-search-input" style={{ borderRadius: 15, height: 35 }}
                            value={value}
                            onChange={onChange}
                            onKeyDown={onKeyDown ? onKeyDown : (e) => {
                                if (e.key === 'Enter') {
                                    onSubmitBtnFunction && onSubmitBtnFunction(e);
                                }
                            }}
                            placeholder={defaultPlaceHolder} />


                        {optionsList.length > 0 &&
                            <div className={`position-absolute top-0 end-0 me-5 `} style={{ zIndex: 4000 }}>
                                <NetaqInput
                                    name='sortBy'
                                    type={'select'}
                                    hideLable={true}
                                    listSelect={optionsList}
                                    noBorderAndBG={true}
                                    onChange={onOptionSelect}
                                    placeholder={translate('web.sortBy', 'SortBy')}
                                />
                            </div>
                        }
                        <div onClick={onSubmitBtnFunction} className="btn btn-danger input-group-append  d-flex  align-items-center justify-content-center" style={{ cursor: 'pointer', zIndex: 2000 }}>
                            <i className=" fa fa-search" ></i>
                        </div>


                    </div>

                    {resultCount > 0 &&
                        <span className='horseCardDescription ms-2'>
                            {resultCount + "  " + translate("web.resultsfound", "Results Found")}
                        </span>
                    }
                </div>

            </div >
        )
    }
}

